import { ButtonGroup, ButtonIcon, Card, Icon, CardV2, Tooltip } from 'pepsico-ds';
import React, { useEffect, useState } from 'react'
import { appNames } from '../../constants/appNames';
import MIInHouseModalNew from "../Modal/MIInHouseModalNew";
import SmartCubeModal from "../Modal/SmartCubeModal";
import { formatNumberWithCommas, returnHyphenIfNull, splitValueWithUnit } from '../../utils/utils';
import InfoIcon from '../Icons/InfoIcon';
import { showChartDisplayError, useButtonItemsArray, vlaidateLandingPageFilters } from './CardUtils';
import { getUserClaims } from '../../utils/auth/unified-auth';
import { useSelector } from 'react-redux'
import BuyerConButtonIcon from "../Button/BuyerConButtonIcon"
import CustomButtons from './CustomButtons';
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';
import { useNavigate } from "react-router-dom";

function MarketIntelCard({ data, capability, selectedYear, userDataLandingPage, landingPageFilters, disabled=false }) {
    const [openModal, setOpenModal] = useState(false)
    const userData = useSelector((state) => state.localData?.data?.oktaUserData);
    const navigate = useNavigate();
    /* istanbul ignore next */
    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            const tempbuttonGroupItems = data && data?.apps && data?.apps.length > 0 ? data?.apps?.filter(item => item.isActive)?.map((app) => ({
                label: app.app,
                chartDisplay: app.chartDisplay,
                onClick: () => window.open(app.url, "_blank"), // Opens the app in a new tab
            })) : [];
            setButtonGroupItems(tempbuttonGroupItems)
        }
    }, [data])

    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [appName, setAppName] = useState('');


    const appDropdownItems = useButtonItemsArray(buttonGroupItems, setAppName, landingPageFilters, setOpenModal, openModal, capability);

    /* istanbul ignore next */
    const enableKPIDisplay = [appNames.spend, appNames.contract, appNames.sustainability, appNames.coman, appNames.compass, appNames.archlet].includes(capability) && appDropdownItems.length < 3 && appDropdownItems?.[1]?.chartDisplay;
    // console.log(data);

    
    return (
        <>
            <div className="kpi-card-header">
                                <div className="kpi-card-title">
                                    {data?.title}
                                    {
                                        data?.edfintegrated &&
                                        <Tooltip direction="bottom" text={staticNotes.EDF_NOTE} style={{ marginTop: 13 }}>
                                            <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible" }} />
                                        </Tooltip>
                                    }
                                </div>
                                <div>
                                    {/* {
                                        appDropdownItems.length === 2 ?
                                            <div className="kpi-card-header-icons">
                                                {BuyerConButtonIcon(enableKPIDisplay, landingPageFilters, setOpenModal, openModal, capability)}
                                            </div>
                                            :
                                            <ButtonGroup
                                                itemCount={1}
                                                groupDisabled={disabled}
                                                items={appDropdownItems}
                                                showMore
                                                size="medium"
                                                className="kpiCardButtomGroup"
                                            />
                                    } */}
                                    <div className="kpi-card-header-icons">
                                    <Tooltip direction="left" 
                                        text={"Go to Market Intelligence Hub"}>
                                        <ButtonIcon
                                                icon="bar_chart"
                                                label=""
                                                onClick={() => {
                                                    navigate("/overview/mi")
                                                } }
                                                size="medium"
                                                // disabled={disabled}
                                                type="default" />
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                            {
                                <div className="kpi-card-middle-content">
                                    <div className="kpi-card-middle-content-left" style={{ width: '75%' }}>
                                        {
                                            data?.currentYearValue ?
                                                <div className="kpi-card-alphanumeric-value">
                                                    {

                                                        <>
                                                            <div className='kpi-card-numeric-value'>
                                                                {formatNumberWithCommas(data?.currentYearValue)}
                                                            </div>
                                                            <div className="kpi-card-alpha-value" style={{ display: "flex" }}>

                                                            </div>
                                                        </>
                                                    }

                                                </div>
                                                :
                                                <div className="kpi-card-alphanumeric-value">
                                                    <div className='kpi-card-numeric-value'>N/A<sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right'/></sup></div>
                                                </div>
                                        }
                                        {/* <div className="kpi-card-numeric-value-tagline">{"Total MI Reports"}</div> */}
                                        <div className="kpi-card-numeric-value-tagline">{data?.description}</div>
                                        <div className="kpi-card-last-update">{data?.lastUpdate && data?.refreshFrequency? `${data.lastUpdate} | ${data.refreshFrequency}`: data?.lastUpdate || data?.refreshFrequency || ''}</div>
                                    </div>
                                    <div className="kpi-card-middle-content-right">
                                        <div className="kpi-card-last-year-value" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'end', height: '100%' }}>
                                            {/* <span className="archlet-card-text" style={{ fontWeight: "700", marginBottom: "5px", whiteSpace: 'nowrap' }}>Report Source</span> */}
                                            <div className="kpi-card-percentage-value" style={{ width: 'fit-content', padding: '4px 9px' }}>
                                                {data?.lastYearValue ? formatNumberWithCommas(data?.lastYearValue) : 0}
                                            </div>
                                            <span className="archlet-card-text" style={{ marginBottom: "10px", whiteSpace: 'nowrap' }}>Sources</span>
                                            <div className="kpi-card-percentage-value" style={{ width: 'fit-content', padding: '4px 9px' }}>{data?.percentage ? formatNumberWithCommas(data?.percentage) : 0}</div>
                                            <span className="archlet-card-text" style={{ whiteSpace: 'nowrap' }}>Reports</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="kpi-card-footer">
                                <Tooltip direction="top-middle" 
                                    text={"Note: FastMarkets (RISI), CMA, Woodmac and S&P Global are not SSO enabled."}>
                                    <Icon alt="" icon="info" size="small" style={{ marginRight: "10px", marginTop: "10px" }}/>
                                </Tooltip>
                                <CustomButtons appList={data?.apps} disabled={disabled}/>
                            </div>

            {
                openModal && capability == appNames.marketIntel && appName == "SmartCube" && <SmartCubeModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} appName={appName} />
            }

            {/* {
                openModal && capability == appNames.marketIntel && appName == "In-house MI Team" && <MarketIntelInHouseModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} capability={capability} userDataLandingPage={userDataLandingPage} />
            } */}
            {
                openModal && capability == appNames.marketIntel && appName == "In-house MI Team" && <MIInHouseModalNew openModal={openModal} setOpenModal={setOpenModal} userData={userData} capability={capability} selectedYear={selectedYear} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} appName={appName} />
            }
        </>
    )
}

export default MarketIntelCard